import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { getMatchZhishu } from "@/api/php/player";
import MatchType from "@/model/MatchType";
import { onMounted, ref } from "vue";
// import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
interface dataProps {
    id: any;
    type: any
}

export default /*#__PURE__*/_defineComponent({
  name: 'Zhishu',
  props: {
    id: { type: null, required: true },
    type: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    id: any;
    type: any
}

_useCssVars(_ctx => ({
  "0899b593-primaryColor": (_unref(primaryColor))
}))

const { t } = useI18n()

// const route = useRoute();

onMounted(() => {
    getData()
});

const datas = ref(null)
const COMPANYNAME = ['', '', 'BET365', t('match.huangguan'), '10BET', t('match.libo'), t('match.mingh'), t('match.bocai'), 'SNAI', t('match.wlxe'), t('match.ysb'), t('match.wd'), 'EuroBet', 'Inter wetten', '12bet', t('match.lij'), t('match.yih'), '18Bet', 'Fun88', '竞彩官方', '', '188', t('match.pb')];

//升盘
const shengpan = ref(0)
//降盘
const jp = ref(0)
//高水
const gs = ref(0)
//低水
const ds = ref(0)

//升盘
const shengpan2 = ref(0)
//降盘
const jp2 = ref(0)
//高水
const gs2 = ref(0)
//低水
const ds2 = ref(0)
const getData = async () => {
    const res: any = await getMatchZhishu({ type_id: props.type, match_id: props.id })
    console.log('指数', res.data);
    
    let temp = {};
    for (let i = 0; i < res.data.length; i++) {
        const element = res.data[i];
        const key = element.company_id
        if (!temp[key]) {
            temp[key] = {};
            temp[key].company_id = element.company_id
        }
        if (element.is_initial == 1) {
            temp[key].initIdex = element
        } else if (element.is_initial == 2) {
            temp[key].realTime = element
        }
    }
    datas.value = temp

    shengpan.value = jqsjp(2, 1, datas.value, function (a, b) {
        if (a == '' || b == '') {
            return false;
        }
        return b > a;
    })
    jp.value = jqsjp(2, 1, datas.value, function (a, b) {
        if (a == '' || b == '') {
            return false;
        }
        return b < a;
    })
    gs.value = jqgs(datas.value)
    ds.value = jqds(datas.value)


    shengpan2.value = rqsjp(2, 1, datas.value, function (a, b) {
        if (a == '' || b == '') {
            return false;
        }
        return b > a;
    })
    jp2.value = rqsjp(2, 1, datas.value, function (a, b) {
        if (a == '' || b == '') {
            return false;
        }
        return b < a;
    })

    gs2.value = rqgs(datas.value)
    ds2.value = rqds(datas.value)


}
const jqgs = (data) => {
    if (!data) return 0;
    let total = 0;
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        let item = data[keys[i]];
        if (item) {
            let real = item.realTime;
            if (real) {
                let asia1 = getasia1(2, 0, real);
                if (asia1 != '') {
                    if (asia1 >= 1) {
                        total++;
                    }
                }

            }
        }
    }
    return total;
}
const rqgs = (data) => {
    if (!data) return 0;
    let total = 0;
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        let item = data[keys[i]];
        if (item) {
            let real = item.realTime;
            if (real) {
                let bs1 = getbs1(2, 0, real)
                if (bs1 != '') {
                    if (bs1 >= 1) {
                        total++;
                    }
                }
            }
        }
    }
    return total;
}
const rqds = (data) => {
    if (!data) return 0;
    let total = 0;
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        let item = data[keys[i]];
        if (item) {
            let real = item.realTime;
            if (real) {
                let bs1 = getbs1(2, 0, real)
                if (bs1 != '') {
                    if (bs1 <= 0.85) {
                        total++;
                    }
                }
            }
        }
    }
    return total;
}

const jqds = (data) => {
    if (!data) return 0;
    let total = 0;
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        let item = data[keys[i]];
        if (item) {
            let real = item.realTime;
            if (real) {
                let asia1 = getasia1(2, 0, real);
                if (asia1 != '') {
                    if (asia1 <= 0.85) {
                        total++;
                    }
                }
            }
        }

    }
    return total;
}

const jqsjp = (a, b, data, func) => {
    if (!data) return 0;
    let total = 0;
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        let item = data[keys[i]];
        if (item) {
            let init = item.initIdex;
            let real = item.realTime;
            if (init && real) {
                if (func(getasia1(a, b, init), getasia1(a, b, real))) {
                    total++;
                }
            }
        }
    }
    return total;
}
const rqsjp = (a, b, data, func) => {
    if (!data) return 0;
    let total = 0;
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        let item = data[keys[i]];
        if (item) {
            let init = item.initIdex;
            let real = item.realTime;
            if (init && real) {
                if (func(getbs1(a, b, init), getbs1(a, b, real))) {
                    total++;
                }
            }
        }
    }
    return total;
}
const getbs1 = (i, j, data) => {
    if (!data.bs || !data.bs[i]) return '';
    let bs = data.bs[i].split(',')
    if (bs.length <= j) return '';
    return bs[j];
}

const getbs = (i, data) => {
    if (!data.bs || !data.bs[2]) return '';
    let bs = data.bs[2].split(',')
    if (bs.length <= i) return '';
    return bs[i];
}
const getasia = (i, data) => {
    if (!data.asia || !data.asia[2]) return '';
    let asia = data.asia[2].split(',')
    if (asia.length <= i) return '';
    return asia[i];
}

const getasia1 = (i, j, data) => {
    if (!data.asia || !data.asia[i]) return '';
    let asia = data.asia[i].split(',')
    if (asia.length <= j) return '';
    return asia[j];
}
const selType = ref(0);

const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;

const getInitEu = (data, i) => {
    if (!data.eu || !data.eu[2]) return '';
    let eu = data.eu[2].split(',')
    if (eu.length <= i) return '';
    return eu[i];
}
const getRealEu = (data, i) => {
    if (!data.eu || !data.eu[2]) return '';
    let eu = data.eu[2].split(',')
    if (eu.length <= i) return '';
    return eu[i];
}

const getResult = (data) => {
    let type = props.type;
    if (parseInt(type) == MatchType.FOOTBALL) {
        let s = Number(getInitEu(data, 0));
        let p = Number(getInitEu(data, 1));
        let f = Number(getInitEu(data, 2));
        if (isNaN(s) && isNaN(p) && isNaN(f)) {
            return '';
        }
        if (isNaN(s) || s == 0) {
            s = 1;
        }
        if (isNaN(p) || p == 0) {
            p = 1;
        }
        if (isNaN(f) || f == 0) {
            f = 1;
        }
        let all = (s * p * f) / (s * p + p * f + s * f);
        return (all * 100).toFixed(1) + "%"
    }
    return '';
}

const __returned__ = { t, props, datas, COMPANYNAME, shengpan, jp, gs, ds, shengpan2, jp2, gs2, ds2, getData, jqgs, rqgs, rqds, jqds, jqsjp, rqsjp, getbs1, getbs, getasia, getasia1, selType, primaryColor, getInitEu, getRealEu, getResult }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})